export default "__VITE_ASSET__jcHdYlOl__"